import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import SecondaryMenu from "../../atoms/secondary-menu";
import MagazineSixColumnGrid from "../../rows/magazine-6column-grid";
import styles from "./styles.m.css";
import { MagazineListingRow } from "../magazine-listing-page";
import { WebEngage, GA, ComScore, DeepBI, Chartbeat, ContentInsights } from "../../../integrations";
import { MagazineIssueOneSliderThreeCards } from "../../rows/magazine-issue-one-slider-3cards/index";

const getStoriesByLabel = collection => {
  return collection.items.filter(({ story = {} }) => story.headline && story.url).reduce((storyMap, item) => {
    const label = get(item, ["associated-metadata", "label"], "மற்றவை");
    if (storyMap[label]) {
      storyMap[label].push(item.story);
    } else {
      storyMap[label] = [item.story];
    }
    return storyMap;
  }, {});
};

const getStoriesWithLabelOnFirst = storyMap => {
  let stories = [];
  Object.keys(storyMap).forEach(key => {
    const tempStories = storyMap[key];
    if (tempStories.length) {
      tempStories[0].label = key;
    }
    stories = stories.concat(tempStories);
  });
  return stories;
};
const generateSecondaryMenu = (storyMap, magazine) => {
  const rootMenuGroup = Object.keys(storyMap).map((label, idx) => {
    return {
      title: label,
      id: idx,
      items: storyMap[label].map(storyObject => {
        return {
          title: storyObject["headline"],
          url: storyObject["url"]
        };
      })
    };
  });

  const firstElement = magazine.name && (
    <span className={styles["magazine-name"]}>{magazine.name.replace(/\(\w+\)/, "")}</span>
  );
  const root = {
    items: rootMenuGroup
  };
  return (
    <SecondaryMenu
      menuGroup={root}
      className={styles["magazine-secondary"]}
      firstElement={firstElement}
      communityColor={magazine.color}
    />
  );
};
export const MagazineLandingPage = ({ pageType, config, data: { collection, magazine, nextIssue, prevIssue } }) => {
  React.useEffect(() => {
    WebEngage.registerPageView();
    ComScore.registerPageView();
    DeepBI.loadScript();
    GA.registerPageView(pageType || "magazine-page", { collection });
    Chartbeat.registerNonStoryPageView(pageType, { collection: collection });
    ContentInsights.registerNonStoryPageView(config.contentInsightsId, pageType, { collection: collection });
  }, []);
  if (!collection) return null;
  const storyMap = getStoriesByLabel(collection);
  const stories = getStoriesWithLabelOnFirst(storyMap);

  return (
    <div className={`main-page ${styles["main-container"]}`}>
      <div className={styles.base}>
        <div className={styles["secondary-menu"]}>{generateSecondaryMenu(storyMap, magazine)}</div>
        <MagazineIssueOneSliderThreeCards
          collection={collection}
          nextIssue={nextIssue}
          prevIssue={prevIssue}
          config={config}
        />
        <MagazineListingRow magazine={magazine} showHeadLine={false} numberOfItems={6} />
        <MagazineSixColumnGrid stories={stories} />
      </div>
    </div>
  );
};

MagazineLandingPage.propTypes = {
  pageType: PropTypes.string,
  config: PropTypes.shape({
    contentInsightsId: PropTypes.string,
    magazines: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        magazineSlug: PropTypes.string,
        name: PropTypes.string,
        url: PropTypes.string,
        vikatanMagazineId: PropTypes.number
      })
    ),
    "publisher-name": PropTypes.string
  }),
  data: PropTypes.shape({
    oldIssues: PropTypes.arrayOf(PropTypes.any),
    config: PropTypes.shape({
      section: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          slug: PropTypes.string
        })
      ),
      magazines: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          magazineSlug: PropTypes.string,
          name: PropTypes.string,
          url: PropTypes.string,
          vikatanMagazineId: PropTypes.number
        })
      ),
      "publisher-name": PropTypes.string
    }),
    collection: PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.string,
          "associated-metadata": PropTypes.shape({
            label: PropTypes.string,
            "page-no": PropTypes.string
          }),
          story: PropTypes.shape({
            id: PropTypes.string,
            contributors: PropTypes.arrayOf(
              PropTypes.shape({
                "role-name": PropTypes.string,
                authors: PropTypes.arrayOf(
                  PropTypes.shape({
                    name: PropTypes.string
                  })
                )
              })
            ),
            headline: PropTypes.string.isRequired,
            alternative: PropTypes.shape({
              home: PropTypes.shape({
                default: PropTypes.shape({
                  headline: PropTypes.string
                })
              })
            }),
            slug: PropTypes.string.isRequired,
            "hero-image-metadata": PropTypes.shape({
              height: PropTypes.number,
              width: PropTypes.number,
              "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
            }),
            "hero-image-s3-key": PropTypes.string,
            "hero-image-caption": PropTypes.string
          })
        })
      )
    })
  })
};

export default MagazineLandingPage;
